import styled, { keyframes } from 'styled-components';

const knightrider = keyframes`
 0% {
    margin-left: 0%;
  }
  50% {
    margin-left: 67%;
  }
  100% {
    margin-left: 0%;
  }
`;

export const LoadingText = styled.div`
  ${({ theme }) => theme.font.t1};
  font-style: normal;
  line-height: 120%;
  color: ${({ theme }) => theme.color.ui2};
`;

export const LoadingBarWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
  height: 0.5rem;
  background: ${({ theme }) => theme.color.ui5};
  border: 0.5px solid ${({ theme }) => theme.color.ui4};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

export const Bar = styled.div`
  position: relative;
  background: ${({ theme }) => theme.color.s1};
  width: 33%;
  height: 100%;
  border: 0.5px solid ${({ theme }) => theme.color.ui4};
  border-radius: ${({ theme }) => theme.radius.xs};
  animation-name: ${knightrider};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
`;
